/**
 * uniqueValidator.js
 * Helper puro para validar campos únicos
 * Zero Hardcode - Todo desde schema
 */

/**
 * Verifica si debe validar unique (solo CREATE)
 */
export function shouldValidateUnique(mode, idValue) {
  // Solo en modo CREATE
  if (mode !== 'create') return false;
  
  // ID debe ser null, 0, undefined o vacío
  return !idValue || idValue === 0 || idValue === '0';
}

/**
 * Construye URL para validación unique
 */
export function buildUniqueValidationUrl(field, value, componentForm) {
  const uniqueConfig = typeof field.unique === 'boolean' 
    ? {} 
    : (field.unique || {});
  
  const targetTable = uniqueConfig.table || componentForm;
  const targetField = uniqueConfig.field || field.name;
  const caseSensitive = uniqueConfig.caseSensitive !== false;

  return `/api/sqlexec_generico/validate/unique?` +
    `table=${targetTable}` +
    `&field=${targetField}` +
    `&value=${encodeURIComponent(value)}` +
    `&caseSensitive=${caseSensitive}`;
}

/**
 * Obtiene mensaje de error para campo duplicado
 */
export function getUniqueErrorMessage(field) {
  const uniqueConfig = typeof field.unique === 'boolean' 
    ? {} 
    : (field.unique || {});
  
  return field.uniqueMessage || 
         uniqueConfig.message || 
         `Este ${field.label.toLowerCase()} ya existe`;
}

/**
 * Valida si un campo tiene configuración unique
 */
export function hasUniqueValidation(field) {
  return field.unique === true || 
         (field.unique && typeof field.unique === 'object');
}